import Text from "../../Components/Text/Text";
import Img1 from '../../assets/images/home/agile-iterative.png'
import Img2 from '../../assets/images/home/risk-first-thinking.png'
import Img3 from '../../assets/images/home/stakeholder-collaboration.png'
import Img4 from '../../assets/images/home/longevity.png'
import { useRef } from "react";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { useState } from "react";
import { useEffect } from "react";

const dataList = [
  {
    src: Img1,
    title: 'Agile & Iterative Development',
    description: "Adaptive delivery that keeps pace with evolving business needs.",
  },
  {
    src: Img2,
    title: 'Risk-First Thinking',
    description: "Addressing uncertainty with a proactive mitigation framework.",
  },
  {
    src: Img3,
    title: 'Stakeholder Collaboration',
    description: "Ensuring all voices are heard, aligned, and moving in the same direction.",
  },
  {
    src: Img4,
    title: 'Engineering for Longevity',
    description: "High-performance software that stands the test of time.",
  },
]

export function RenderContent ({ item, index, show }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <div className={`flex-1 transition-all duration-700 ${active ? "" : "opacity-0 translate-y-96"}`}>
      <img src={item.src} alt={item.title} className="mb-6" />
      <Text type="h1" size="d2" className="mb-6 font-bold min-h-[64px] max-sm:min-h-0">{item.title}</Text>
      <Text type="p" size="bodyXl" className="mb-3">
        {item.description}
      </Text>
    </div>
  )
}
 
export default function DeliverScalableSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <div className="relative" ref={ref}>
      <div className="mx-auto container my-[240px] max-sm:my-[120px] px-4">
        <Text 
          type="h1" 
          size="d5" 
          className={`mb-16 transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >Deliver Scalable, Future-Proof Software</Text>
        <div className="gap-16 max-sm:gap-8 grid max-sm:!grid-cols-1 max-md:grid-cols-2 grid-cols-4">
          {
            dataList.map((item, index) => (<RenderContent key={index} item={item} show={show} />))
          }
        </div>
      </div>
    </div>
  );
}